/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
    'sidebar.gestionbodegas': 'Warehouse Management',
    'sidebar.bodegas': 'Warehouse',
    'gestionBodega.medida.dimensiones': 'M',
    'gestionBodega.medida.peso': 'Kg',
    'gestionBodega.medida.coordenadas': 'Gr',
    'gestionBodega.agregarBodega': 'Create Warehouse',
    'gestionBodega.editarBodega': 'Edit Warehouse',
    'gestionBodega.datosGenerales': 'General data',
    'gestionBodega.divisionesBodega': 'Warehouse divisions',
    'gestionBodega.personasAsociadas': 'Associated people',
    'gestionBodega.MáximosMínimos': 'Maximums and Minimums',
    'gestionBodega.divisionesPorDefecto': 'Default divisions',
    'gestionBodega.BodegaDescripcion': 'Warehouse description',
    'gestionBodega.BodegaCodigo': 'Warehouse code',
    'gestionBodega.TipoBodegaDescripcion': 'Warehouse type',
    'gestionBodega.BodegaPadre': 'Parent warehouse',
    'gestionBodega.DescripcionCiudad': 'City',
    'gestionBodega.Agencias': 'Agencys',
    'gestionBodega.Ancho': 'Width',
    'gestionBodega.Alto': 'High',
    'gestionBodega.Largo': 'Long',
    'gestionBodega.Latitud': 'Latitude',
    'gestionBodega.Longitud': 'Length',
    'gestionBodega.Estado': 'State',
    'gestionBodega.dimensionesInvalidas': 'The measures entered are invalid',
    'gestionBodega.Propiedades.alerta.camposNulos': 'Please enter all available fields',
    'gestionBodega.Propiedades.BodegaTipoPropiedadDescripcion': 'Type Property',
    'gestionBodega.Propiedades.DescripcionItem': 'Product',
    'gestionBodega.Propiedades.FamiliaDescripcion': 'Family',
    'gestionBodega.Propiedades.BodegaPropiedadTexto': 'Description',
    'gestionBodega.Propiedades.DescripcionUnidad': 'Unit',
    'gestionBodega.Propiedades.Estado': 'State',
    'gestionBodega.Propiedades.Cantidad': 'Quantity',
    'gestionBodega.titulo.datosBodega': 'Warehouse data',
    'gestionBodega.titulo.medidasBodega': 'Warehouse measures',
    'gestionBodega.titulo.propiedadesBodega': 'Warehouse properties',
    'gestionBodega.propieades.titulo.crearPropiedad': 'Create warehouse property',
    'gestionBodega.propieades.titulo.editarPropiedad': 'Edit warehouse property',
    'gestionBodega.Agencia': 'Agency',
    'bodegasPersonas.PersonaId': 'Person',
    'bodegasPersonas.Estado': 'State',
    'bodegasPersonas.BodegaPrincipal': 'Main warehouse',
    'bodegasPersonas.agregarBodegasPersonas': 'Associate person',
    'bodegasPersonas.modificarBodegasPersonas': 'Edit associated person',
    'divisionBodega.propiedadesDivision': 'Properties division',
    'divisionBodega.datosDivision': 'Division data',
    'divisionBodega.medidasDivision': 'Division dimensions',
    'divisionBodega.agregarDivisionBodega': 'Create division',
    'divisionBodega.editarDivisionBodega': 'Edit division',
    'divisionBodega.TipoDivision': 'Type division',
    'divisionBodega.Fila': 'Row',
    'divisionBodega.Columna': 'Column',
    'divisionBodega.Piso': 'Floor',
    'divisionBodega.DivisionCodigoBarras': 'Barcode',
    'divisionBodega.DivisionDescripcion': 'Description',
    'divisionBodega.Ancho': 'Width',
    'divisionBodega.Largo': 'length',
    'divisionBodega.Alto': 'height',
    'divisionBodega.Peso': 'Weight',
    'divisionBodega.VolumenDisponible': 'Available volume',
    'divisionBodega.PesoDisponible': 'Available weight',
    'divisionBodega.Estado': 'State',
    'bodegasPersonas.NombrePersona': 'Name',
    'divisionBodega.Propiedades.agregarPropiedadDivision': 'Create division property',
    'divisionBodega.Propiedades.editarPropiedadDivision': 'Edit division property',
    'divisionBodega.Propiedades.BodegaTipoPropiedadDescripcion': 'Type Property',
    'divisionBodega.Propiedades.DescripcionItem': 'Product',
    'divisionBodega.Propiedades.FamiliaDescripcion': 'Family',
    'divisionBodega.Propiedades.BodegaPropiedadTexto': 'Description',
    'divisionBodega.Propiedades.DescripcionUnidad': 'Unit',
    'divisionBodega.Propiedades.Estado': 'State',
    'divisionBodega.Propiedades.Cantidad': 'Quantity',
    'divisionesDocumentosDefecto.TituloDivisionDefecto': 'Division by defect',
    'divisionesDocumentosDefecto.DivisionDescripcion': 'Division',
    'divisionesDocumentosDefecto.TipoMovimientoDescripcion': 'Document type',
    'divisionesDocumentosDefecto.agregarDivisionesDocumentosDefecto': 'Create default division',
    'divisionesDocumentosDefecto.modificarDivisionesDocumentosDefecto': 'Edit default division',
    'gestionauditorias.alerta.segundoConteo': 'Are you sure you want to start the second count?',
    'gestionauditorias.alerta.finalizarConteo': 'Are you sure you want to finish the count?',
    'gestionBodega.Direccion': 'Address',
    'divisionBodega.ColumnaInactiva': ' Inactive column record, select a new one',
    'divisionBodega.TipoDivisionInactiva': 'Division type record inactive, select a new one',
    'divisionBodega.PisoInactivo': 'Register floor inactive, select a new one',
    'divisionBodega.FilaInactiva': 'Row record inactive, select a new one',
};
